import React, { useState } from 'react';
import styled from 'styled-components';

// Definindo a interface para as props do componente
interface DecimalInputProps {
  value: number;
  onChange: (value: number) => void;
  placeholder?: string;
  decimalPlaces?: number; // Número de casas decimais permitidas
  disabled?: boolean
}

// Estilizando o input
const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
`;

export const DecimalInput: React.FC<DecimalInputProps> = ({
  value,
  onChange,
  placeholder,
  decimalPlaces = 2,
  disabled,
}) => {
  const [displayValue, setDisplayValue] = useState<string>(
    value.toFixed(decimalPlaces).replace('.', ',') // Formata inicialmente com vírgula
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = event.target.value;

    const isValidInput = /^(\d*,?\d*)?$/.test(inputValue);

    if (isValidInput) {

      let [integerPart, decimalPart = ""] = inputValue.split(',');

      integerPart = integerPart.replace(/^0+/, '') || '0';

      decimalPart = decimalPart.replace(/^0+/, '');

      if (decimalPart.length > decimalPlaces) {
        decimalPart = decimalPart.slice(0, decimalPlaces);
      }

      let formattedValue = integerPart;
      if (inputValue.includes(',')) {
        formattedValue += `,${decimalPart}`;
      }

      setDisplayValue(formattedValue);
      const numericValue = parseFloat(formattedValue.replace(',', '.'));
      if (!isNaN(numericValue)) {
        onChange(numericValue);
      }
    }
  };


  const handleBlur = () => {
    // Formata o valor ao sair do input
    const numericValue = parseFloat(displayValue.replace(',', '.'));
    if (!isNaN(numericValue)) {
      setDisplayValue(
        numericValue.toFixed(decimalPlaces).replace('.', ',') // Formata com vírgula
      );
    } else {
      setDisplayValue(''); // Limpa o campo se o valor for inválido
    }
  };

  return (
    <Input
      type="text"
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};

